export const CLASS_TITLE =
  "Klassförsäljning – tjäna pengar till klassen | SalesPartner";
export function getClassLandingMeta(max) {
  const amount =
    Number.isFinite(Number(max)) && max != null
      ? Math.floor(Number(max)).toLocaleString("sv-SE")
      : null;
  let description =
    amount == null
      ? "Klassförsäljning med personliga säljlänkar och digital beställning. Samla in pengar till klassresan med provision per produkt."
      : `Klassförsäljning med personliga säljlänkar: eleverna delar sin länk, kunden betalar online och klassen tjänar upp till ${amount} kr per såld produkt till klassresan.`;
  if (description.length > 160)
    description = description.replace("per såld produkt", "per produkt");
  return {
    title: CLASS_TITLE,
    description,
    h1: `Klassförsäljning – tjäna pengar till klassresan${amount == null ? "" : `, upp till ${amount} kr per såld produkt`}`,
  };
}
